export default {
  type: {
    label: "Тип",
    options: {
      text: "Текст",
      choice: "Выбор",
      perm: "Перестановка",
      list: "Лист",
      link: "Ссылка",
    },
  },
};
